import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useFormContext } from "react-hook-form";
import { Country, countryArray } from "@/types";

export const AddressStep = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>((props, ref) => {
  const { register, setValue, watch, formState: { errors } } = useFormContext();
  const selectedCountry = watch("owner.address.country");

  return (
    <div {...props} ref={ref} className={`space-y-6 ${props.className || ""}`}>
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="buildingNumber">Building Number *</Label>
          <Input
            id="buildingNumber"
            {...register("owner.address.buildingNumber", { required: true })}
            className={errors.owner?.address?.buildingNumber ? "border-destructive ring-destructive" : ""}
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="street">Street *</Label>
          <Input
            id="street"
            {...register("owner.address.street", { required: true })}
            className={errors.owner?.address?.street ? "border-destructive ring-destructive" : ""}
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="town">Town *</Label>
          <Input
            id="town"
            {...register("owner.address.town", { required: true })}
            className={errors.owner?.address?.town ? "border-destructive ring-destructive" : ""}
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="stateProvince">State/Province *</Label>
          <Input
            id="stateProvince"
            {...register("owner.address.stateProvince", { required: true })}
            className={errors.owner?.address?.stateProvince ? "border-destructive ring-destructive" : ""}
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="postCode">Post Code *</Label>
          <Input
            id="postCode"
            {...register("owner.address.postCode", { required: true })}
            className={errors.owner?.address?.postCode ? "border-destructive ring-destructive" : ""}
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="country">Country *</Label>
          <Select
            value={selectedCountry || ""}
            onValueChange={(value) => setValue("owner.address.country", value, { shouldValidate: true })}
          >
            <SelectTrigger className={`h-8 text-sm ${errors.owner?.address?.country ? "border-destructive ring-destructive" : ""}`}>
              <SelectValue placeholder="Select a country" />
            </SelectTrigger>
            <SelectContent>
              {countryArray.map((country) => (
                <SelectItem key={country} value={country}>
                  {country}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <input
            {...register("owner.address.country", { required: true })}
            type="hidden"
          />
        </div>
      </div>
    </div>
  );
});